import { EditorState } from "@tiptap/pm/state";

import globalToasterRef from "@/base/globalToasterRef";
import {
  EVENT_TOAST_INVALID_TEXT_LENGTH,
  GUIDED_HIGHLIGHTING_ANSWER_MAX_LENGTH,
} from "@/view/TiptapArticleBody/components/TextSelectionMenu/GuidedHighlightingTextSelectionMenu/GuidedHighlightingTextSelectionMenu.constants";
import { getDynamicData } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { IHandleHighlightingTextProps } from "@/view/utils/useGuidedHighlightingStudentAnswer/types";

type THandleHighlightingText = (props: IHandleHighlightingTextProps) => void;

export function getGuidedHighlightingOnClick(
  state: EditorState,
  handleHighlightingText: THandleHighlightingText,
) {
  const { doc, selection } = state;
  const { from, to } = selection;
  const { activeGuidedHighlightingQuestion, levelId } = getDynamicData(state);

  return () => {
    if (!activeGuidedHighlightingQuestion) return;

    const selectedText = doc.textBetween(from, to, " ");

    if (selectedText.length <= GUIDED_HIGHLIGHTING_ANSWER_MAX_LENGTH) {
      handleHighlightingText({
        selectedText,
        startIndex: from,
        endIndex: to,
        articleId: levelId,
      });
    } else {
      globalToasterRef.current.displayToast(EVENT_TOAST_INVALID_TEXT_LENGTH);
    }
  };
}
